import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FeatureFlagDirective } from './directives/feature-flag.directive';
import { AdviserNamePipe } from './pipes/adviser-name.pipe';
import { FullNamePipe } from './pipes/full-name.pipe';
import { CustomisationDirective } from './directives/customisation.directive';

@NgModule({
  declarations: [AdviserNamePipe, FullNamePipe, FeatureFlagDirective, CustomisationDirective],
  imports: [CommonModule],
  exports: [AdviserNamePipe, FullNamePipe, FeatureFlagDirective, CustomisationDirective],
  providers: []
})
export class SparkCoreModule { }
